/**
 * Page Loading
 * Full-page loading state
 */

import { LoadingSpinner } from './LoadingSpinner'

interface PageLoadingProps {
  message?: string
}

export function PageLoading({ message = 'Loading...' }: PageLoadingProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <LoadingSpinner size="lg" message={message} />
    </div>
  )
}
